module.exports = __webpack_public_path__ + "svg/photo-prev.svg?b2a39cc254f26338d8d021b5a173f948";